import React from "react";
import { Badge } from "../ui/badge";
import {
  FlagType,
  FlagTypeChipColors,
  FlagTypeChipLabels,
  FlagTypeIcons,
} from "../../models/ClientConfiguration/FlaggingConfiguration";

interface FlagTypeChipProps {
  flagType: FlagType;
}

const FlagTypeChip: React.FC<FlagTypeChipProps> = ({ flagType }) => {
  const Icon = FlagTypeIcons[flagType];

  return (
    <Badge variant={FlagTypeChipColors[flagType] ?? "neutral"}>
      {Icon && <Icon className="size-3" />}
      {FlagTypeChipLabels[flagType] ?? flagType}
    </Badge>
  );
};

export default FlagTypeChip;
